/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_BackInputs */

const en_student_back = /** @type {(inputs: Student_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to students`)
};

const he_student_back = /** @type {(inputs: Student_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לתלמידים`)
};

/**
* | output |
* | --- |
* | "Back to students" |
*
* @param {Student_BackInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_back = /** @type {((inputs?: Student_BackInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_BackInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_back(inputs)
	return he_student_back(inputs)
});